
export default {
  layoutProps: {
    titleToken: "faq.title",
  },

  // validate ({ store }) { return store.getters["user/isAdmin"] },
  validate ({ i18n }) { return i18n.locale === "ru" },

  data: () => ({
    items: [],
  }),

  async fetch () {
    await this.fetchItems()
  },

  computed: {
    items_ () {
      return this.items.filter(i => i.question && i.answer)
    },
  },

  methods: {
    async fetchItems () {
      const [res, err] = await this.$api.faq.getFaq()
      if (err) {
        console.error(err)
        return
      }
      this.items = res
    },
  },
}
